import {
  Box,
  Heading,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  OrderedList,
  Link,
  Divider,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Footer } from "../components/Footer/Footer";
import { Navigation } from "../components/header/Navigation";
import { useContaxt } from "../context/Context";

export function Datasecruity() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { color } = useContaxt();

  return (
    <>
      <Helmet>
        <title>
          WebWerk am Meer | Datenschutzerklärung | Webdesign aus Kiel
        </title>
        <meta
          name="title"
          content="WebWerk am Meer | Datenschutzerklärung | Webdesign aus Kiel"
        />
        <meta
          name="description"
          content="Datenschutz spielt bei uns als Webdesign Agentur in Kiel eine große Rolle. Jetzt unsere Experten im Webdesign Bereich in Kiel in Anspruch nehmen."
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="WebWerk am Meer | Datenschutzerklärung | Webdesign aus Kiel"
        />
        <meta
          property="og:description"
          content="Datenschutz spielt bei uns als Webdesign Agentur in Kiel eine große Rolle. Jetzt unsere Experten im Webdesign Bereich in Kiel in Anspruch nehmen."
        />
        <meta
          property="og:image"
          content="https://webwerk-am-meer.de/data/webwerk_meta_preview.jpg"
        />
        <meta
          property="twitter:title"
          content="WebWerk am Meer | Datenschutzerklärung | Webdesign aus Kiel"
        />
        <meta
          property="twitter:description"
          content="Datenschutz spielt bei uns als Webdesign Agentur in Kiel eine große Rolle. Jetzt unsere Experten im Webdesign Bereich in Kiel in Anspruch nehmen."
        />
        <meta
          property="twitter:image"
          content="https://webwerk-am-meer.de/data/webwerk_meta_preview.jpg"
        />
      </Helmet>
      <Navigation />
      <Stack
        as="main"
        role="main"
        px={[5, 5, 5, 10]}
        py={[10, 15, 20, 20]}
        mt={10}
        fontSize={20}
        textAlign="left"
        maxW="960px"
        mx="auto"
        spacing={8}
      >
        <Heading as={"h1"} size="xl" color="black">
          Datenschutzerklärung
        </Heading>

        <Box
          bg="gray.50"
          border="1px"
          borderColor="gray.200"
          p={5}
          rounded="md"
        >
          <Heading
            as={"h2"}
            size="md"
            mb={3}
            style={{ color: color.mainColor }}
          >
            Inhalt
          </Heading>
          <OrderedList spacing={1} pl={6} color="black">
            <ListItem>
              <Link href="#1-verantwortlicher" color={color.mainColor}>
                Verantwortlicher
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#2-allgemeines" color={color.mainColor}>
                Allgemeines zur Datenverarbeitung
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#3-server-logfiles" color={color.mainColor}>
                Bereitstellung der Website und Server-Logfiles
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#4-cookies" color={color.mainColor}>
                Cookies, ähnliche Technologien und Consent-Management
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#5-kontakt" color={color.mainColor}>
                Kontaktformular und Kontaktaufnahme per E-Mail
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#6-bewerbungen" color={color.mainColor}>
                Online-Bewerbungen
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#7-meta-pixel" color={color.mainColor}>
                Einsatz von Meta Pixel und Meta Marketing-Diensten
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#8-google-analytics" color={color.mainColor}>
                Google Analytics
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#9-hosting" color={color.mainColor}>
                Hosting der Website
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#10-microsoft365" color={color.mainColor}>
                E-Mail-Kommunikation über Microsoft 365
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#11-empfaenger" color={color.mainColor}>
                Empfänger und Kategorien von Empfängern
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#12-speicherdauer" color={color.mainColor}>
                Speicherdauer und Löschung von Daten
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#13-rechte" color={color.mainColor}>
                Ihre Rechte als betroffene Person
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#14-widerspruch" color={color.mainColor}>
                Widerspruchsrecht nach Art. 21 DSGVO
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#15-datensicherheit" color={color.mainColor}>
                Datensicherheit
              </Link>
            </ListItem>
            <ListItem>
              <Link href="#16-aenderungen" color={color.mainColor}>
                Änderungen dieser Datenschutzerklärung
              </Link>
            </ListItem>
          </OrderedList>
        </Box>

        <Divider />

        <Heading
          as={"h2"}
          size="lg"
          id="1-verantwortlicher"
          style={{ color: color.mainColor }}
        >
          1. Verantwortlicher
        </Heading>
        <Text color="black">
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und
          anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie
          sonstiger datenschutzrechtlicher Bestimmungen ist:
        </Text>
        <Text color="black">
          Target KI GmbH
          <br />
          Dubenhorst 9
          <br />
          24114 Kiel
          <br />
          Deutschland
          <br />
          E-Mail:{" "}
          <Link href="mailto:info@target-ki.de" color={color.mainColor}>
            info@target-ki.de
          </Link>
          <br />
          (nachfolgend „wir“ oder „uns“)
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="2-allgemeines"
          style={{ color: color.mainColor }}
        >
          2. Allgemeines zur Datenverarbeitung
        </Heading>
        <Text color="black">
          Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich
          nur, soweit dies zur Bereitstellung einer funktionsfähigen Website
          sowie unserer Inhalte und Leistungen erforderlich ist, zur
          Beantwortung von Anfragen oder sofern Sie hierin eingewilligt haben.
        </Text>
        <Text color="black">Rechtsgrundlagen sind insbesondere:</Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</ListItem>
          <ListItem>
            Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung oder -anbahnung)
          </ListItem>
          <ListItem>
            Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)
          </ListItem>
        </UnorderedList>

        <Heading
          as={"h2"}
          size="lg"
          id="3-server-logfiles"
          style={{ color: color.mainColor }}
        >
          3. Bereitstellung der Website und Server-Logfiles
        </Heading>
        <Text color="black">
          Bei jedem Aufruf unserer Website erfasst unser System automatisiert
          Daten und Informationen vom Computersystem des aufrufenden Geräts.
        </Text>
        <Text color="black">Folgende Daten können hierbei erhoben werden:</Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Datum und Uhrzeit des Zugriffs</ListItem>
          <ListItem>aufgerufene Seite/Datei</ListItem>
          <ListItem>übertragene Datenmenge</ListItem>
          <ListItem>
            Meldung, ob der Abruf erfolgreich war (HTTP-Statuscode)
          </ListItem>
          <ListItem>zuvor besuchte Seite (Referrer-URL)</ListItem>
          <ListItem>verwendeter Browsertyp und -version</ListItem>
          <ListItem>verwendetes Betriebssystem</ListItem>
          <ListItem>(verkürzte) IP-Adresse des zugreifenden Geräts</ListItem>
        </UnorderedList>
        <Text color="black">
          Die Daten werden in den Logfiles unseres Systems gespeichert. Eine
          Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten
          des Nutzers findet nicht statt.
        </Text>
        <Text color="black" fontWeight="semibold">
          Zweck der Verarbeitung
        </Text>
        <Text color="black">
          Die vorübergehende Speicherung der IP-Adresse durch das System ist
          notwendig, um eine Auslieferung der Website an den Rechner des Nutzers
          zu ermöglichen und um die Sicherheit und Stabilität der Systeme zu
          gewährleisten (z. B. zur Abwehr von Angriffen). IHK München
        </Text>
        <Text color="black">
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes
          Interesse liegt in der Gewährleistung der technischen
          Funktionsfähigkeit unserer Website und der IT-Sicherheit.
        </Text>
        <Text color="black" fontWeight="semibold">
          Speicherdauer
        </Text>
        <Text color="black">
          Logfiles werden in der Regel für bis zu 7 Tage gespeichert und
          anschließend gelöscht. Eine darüberhinausgehende Speicherung ist
          möglich; in diesem Fall werden die IP-Adressen anonymisiert, sodass
          eine Zuordnung zu einem Nutzer nicht mehr möglich ist, oder die
          längere Speicherung erfolgt nur zu Beweiszwecken bei
          sicherheitsrelevanten Vorfällen.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="4-cookies"
          style={{ color: color.mainColor }}
        >
          4. Cookies, ähnliche Technologien und Consent-Management
        </Heading>
        <Text color="black">
          Unsere Website verwendet Cookies und ähnliche Technologien (z. B.
          Local Storage), um bestimmte Funktionen bereitzustellen, die Nutzung
          zu analysieren und – nach Ihrer Einwilligung – Marketing-Tools (z. B.
          Google Analytics, Meta Pixel) einzusetzen.
        </Text>
        <Heading as={"h3"} size="md" style={{ color: color.mainColor }}>
          4.1. Technisch notwendige Cookies
        </Heading>
        <Text color="black">
          Technisch notwendige Cookies sind erforderlich, um die grundlegenden
          Funktionen unserer Website bereitzustellen (z. B. Spracheinstellungen,
          Formularschutz, Consent-Einstellungen). Ohne diese Cookies kann die
          Website nicht fehlerfrei dargestellt werden.
        </Text>
        <Text color="black">
          Rechtsgrundlage für die Speicherung und Auslesung solcher
          Informationen ist § 25 Abs. 2 Nr. 2 TTDSG, die anschließende
          Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
        </Text>
        <Heading as={"h3"} size="md" style={{ color: color.mainColor }}>
          4.2. Cookies zu Statistik- und Marketingzwecken
        </Heading>
        <Text color="black">
          Wir setzen darüber hinaus – nur nach Ihrer Einwilligung – Cookies und
          ähnliche Technologien zu folgenden Zwecken ein:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            Reichweitenmessung &amp; Statistik (z. B. Google Analytics)
          </ListItem>
          <ListItem>Marketing und Remarketing (z. B. Meta Pixel)</ListItem>
        </UnorderedList>
        <Text color="black">
          Rechtsgrundlage für das Setzen und Auslesen dieser Cookies ist Ihre
          Einwilligung gemäß § 25 Abs. 1 TTDSG. Die weitere Datenverarbeitung
          erfolgt auf Basis von Art. 6 Abs. 1 lit. a DSGVO.
        </Text>
        <Heading as={"h3"} size="md" style={{ color: color.mainColor }}>
          4.3. Consent-Management
        </Heading>
        <Text color="black">
          Beim ersten Besuch unserer Website werden Sie über ein
          Cookie-/Consent-Banner um Ihre Einwilligung in die Nutzung nicht
          notwendiger Cookies und Tools gebeten. Dort können Sie einzelnen
          Kategorien (Statistik, Marketing) zustimmen oder sie ablehnen, Ihre
          Auswahl speichern sowie Ihre Einwilligung jederzeit mit Wirkung für
          die Zukunft ändern oder widerrufen. Sie können Ihre Einstellungen
          jederzeit über den auf unserer Website bereitgestellten Link
          „Cookie-Einstellungen“ (z. B. im Footer) aufrufen und anpassen.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="5-kontakt"
          style={{ color: color.mainColor }}
        >
          5. Kontaktformular und Kontaktaufnahme per E-Mail
        </Heading>
        <Text color="black">
          Auf unserer Website steht Ihnen ein Kontaktformular zur Verfügung, das
          für die elektronische Kontaktaufnahme genutzt werden kann. Nutzen Sie
          diese Möglichkeit, so werden die in der Eingabemaske eingegebenen
          Daten an uns übermittelt und gespeichert. Dies sind in der Regel:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Name (Pflichtfeld)</ListItem>
          <ListItem>E-Mail-Adresse (Pflichtfeld)</ListItem>
          <ListItem>Ihre Nachricht (Pflichtfeld)</ListItem>
          <ListItem>Telefonnummer (optional)</ListItem>
        </UnorderedList>
        <Text color="black">
          Alternativ ist eine Kontaktaufnahme über die bereitgestellte
          E-Mail-Adresse möglich. In diesem Fall werden die mit der E-Mail
          übermittelten personenbezogenen Daten gespeichert und in unserem
          E-Mail-System (Microsoft 365 / Outlook) verarbeitet.
        </Text>
        <Text color="black" fontWeight="semibold">
          Zweck der Verarbeitung
        </Text>
        <Text color="black">
          Die Verarbeitung der personenbezogenen Daten dient uns zur Bearbeitung
          Ihrer Anfrage sowie zur Vorbereitung und Durchführung vorvertraglicher
          oder vertraglicher Maßnahmen (z. B. Angebotsabgabe, Rückfragen,
          Vertragsvorbereitung).
        </Text>
        <Text color="black" fontWeight="semibold">
          Rechtsgrundlagen
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage auf den Abschluss
            eines Vertrages abzielt
          </ListItem>
          <ListItem>
            Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
            Bearbeitung von Anfragen)
          </ListItem>
        </UnorderedList>
        <Text color="black" fontWeight="semibold">
          Speicherdauer
        </Text>
        <Text color="black">
          Die über das Kontaktformular oder per E-Mail übermittelten Daten
          speichern wir grundsätzlich, solange dies zur Bearbeitung der Anfrage
          erforderlich ist. Im Anschluss werden die Daten gelöscht, soweit keine
          gesetzlichen Aufbewahrungsfristen entgegenstehen. Sofern es sich um
          geschäftlich relevante Korrespondenz handelt, kann eine Aufbewahrung
          von bis zu 6 bzw. 10 Jahren nach handels- und steuerrechtlichen
          Vorgaben erfolgen (z. B. nach § 147 AO, § 257 HGB). NWB Datenbank+1
        </Text>
        <Text color="black">
          Sie können der Verarbeitung der Daten, die auf Art. 6 Abs. 1 lit. f
          DSGVO beruht, jederzeit widersprechen (siehe Abschnitt „Ihre Rechte“).
          In einem solchen Fall kann die Kommunikation ggf. nicht fortgeführt
          werden.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="6-bewerbungen"
          style={{ color: color.mainColor }}
        >
          6. Online-Bewerbungen (Bewerbungsformular / E-Mail)
        </Heading>
        <Text color="black">
          Auf unserer Website können Sie sich über ein Bewerbungsformular oder
          per E-Mail bei uns bewerben. Dabei verarbeiten wir insbesondere
          folgende Daten:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Name</ListItem>
          <ListItem>E-Mail-Adresse</ListItem>
          <ListItem>Telefonnummer</ListItem>
          <ListItem>Antworten auf von uns gestellte Ja/Nein-Fragen</ListItem>
          <ListItem>ggf. weitere von Ihnen mitgeteilte Informationen</ListItem>
        </UnorderedList>
        <Text color="black" fontWeight="semibold">
          Zweck der Verarbeitung
        </Text>
        <Text color="black">
          Die Verarbeitung erfolgt zum Zweck der Entscheidung über die
          Begründung eines Beschäftigungsverhältnisses.
        </Text>
        <Text color="black" fontWeight="semibold">
          Rechtsgrundlage
        </Text>
        <Text color="black">
          Art. 6 Abs. 1 lit. b DSGVO i. V. m. § 26 BDSG (Anbahnung eines
          Beschäftigungsverhältnisses).
        </Text>
        <Text color="black" fontWeight="semibold">
          Speicherdauer
        </Text>
        <Text color="black">
          Bewerbungsunterlagen werden von uns für die Dauer des
          Bewerbungsverfahrens gespeichert. Nach Abschluss des Verfahrens werden
          Ihre Daten in der Regel nach 6 Monaten gelöscht, sofern kein
          Beschäftigungsverhältnis zustande kommt und keine weitergehende
          Einwilligung zur längeren Aufbewahrung erteilt wurde (z. B. für einen
          Bewerberpool) oder gesetzliche Vorschriften einer Löschung
          entgegenstehen.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="7-meta-pixel"
          style={{ color: color.mainColor }}
        >
          7. Einsatz von Meta Pixel und Meta Marketing-Diensten
        </Heading>
        <Text color="black">
          Wir setzen auf unseren Webseiten das Meta Pixel und weitere
          Marketing-Dienste der Meta Platforms Ireland Limited, 4 Grand Canal
          Square, Dublin 2, Irland („Meta“) ein (u. a. Conversion-Tracking,
          Custom Audiences, Retargeting).
        </Text>
        <Text color="black">
          Das Meta Pixel ist ein JavaScript-Code, der beim Aufruf unserer Seiten
          geladen wird und die Speicherung sowie das Auslesen von Informationen
          auf Ihrem Endgerät ermöglicht (z. B. Cookies). Dadurch können wir
          nachvollziehen, ob Nutzer über Meta-Werbeanzeigen (z. B. bei Facebook
          oder Instagram) auf unsere Website gelangt sind, und Zielgruppen für
          Werbeanzeigen (sog. „Custom Audiences“) bilden.
        </Text>
        <Text color="black">
          Hierbei können insbesondere folgende Informationen verarbeitet werden:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            Informationen aus dem http-Header (u. a. IP-Adresse, Browsertyp,
            Referrer-URL, Standort der Seite)
          </ListItem>
          <ListItem>gerätespezifische Informationen</ListItem>
          <ListItem>
            bei Meta bereits gesetzte Cookies (z. B. „_fbp“, „fr“)
          </ListItem>
          <ListItem>
            Informationen über Interaktionen mit unserer Website (z. B. Aufruf
            bestimmter Seiten, Klicks auf Schaltflächen oder Formulare)
          </ListItem>
        </UnorderedList>
        <Text color="black" fontWeight="semibold">
          Zwecke der Verarbeitung
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            Messung und Auswertung der Wirksamkeit unserer Meta-Werbeanzeigen
            (Conversion-Tracking)
          </ListItem>
          <ListItem>
            Ausspielen von zielgruppenorientierter Werbung (Retargeting)
          </ListItem>
          <ListItem>Optimierung unserer Werbemaßnahmen</ListItem>
        </UnorderedList>
        <Text color="black" fontWeight="semibold">
          Rechtsgrundlage
        </Text>
        <Text color="black">
          Der Einsatz des Meta Pixels erfolgt nur nach Ihrer Einwilligung über
          unser Consent-Banner. Setzen/Auslesen der Cookies: § 25 Abs. 1 TTDSG;
          weitere Verarbeitung personenbezogener Daten: Art. 6 Abs. 1 lit. a
          DSGVO. Sie können Ihre Einwilligung jederzeit mit Wirkung für die
          Zukunft über die „Cookie-Einstellungen“ auf unserer Website
          widerrufen.
        </Text>
        <Text color="black" fontWeight="semibold">
          Datenübermittlung in Drittländer
        </Text>
        <Text color="black">
          Die Verarbeitung kann auch in den USA erfolgen. Hierfür verwendet Meta
          u. a. Standardvertragsklauseln der EU-Kommission nach Art. 46 Abs. 2
          lit. c DSGVO als geeignete Garantien für ein angemessenes
          Datenschutzniveau. Dennoch besteht das Risiko, dass Behörden in
          Drittländern auf die Daten zugreifen können, ohne dass Ihnen hiergegen
          wirksame Rechtsbehelfe zustehen.
        </Text>
        <Text color="black" fontWeight="semibold">
          Speicherdauer
        </Text>
        <Text color="black">
          Informationen, die mithilfe des Meta Pixels erfasst werden, können von
          Meta für bis zu 24 Monate gespeichert werden. Die von uns erstellten
          Zielgruppenlisten (Custom Audiences) werden gelöscht, sobald sie für
          die Zwecke, für die sie erstellt wurden, nicht mehr erforderlich sind.
        </Text>
        <Text color="black">
          Weitere Informationen zur Datenverarbeitung durch Meta finden Sie in
          der Datenschutzerklärung von Meta (Facebook/Instagram):{" "}
          <Link
            href="https://de-de.facebook.com/privacy/policy/"
            target="_blank"
            rel="nofollow"
            color={color.mainColor}
          >
            https://de-de.facebook.com/privacy/policy/
          </Link>
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="8-google-analytics"
          style={{ color: color.mainColor }}
        >
          8. Google Analytics
        </Heading>
        <Text color="black">
          Wir setzen auf unseren Webseiten den Webanalysedienst Google Analytics
          ein, bereitgestellt von Google Ireland Limited, Gordon House, Barrow
          Street, Dublin 4, Irland („Google“). Google Analytics verwendet
          Cookies, die eine Analyse der Benutzung der Website durch Sie
          ermöglichen.
        </Text>
        <Text color="black">
          Die hierdurch erzeugten Informationen über Ihre Benutzung unserer
          Website können u. a. sein:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>abgerufene Seiten, Klickpfade</ListItem>
          <ListItem>Anzahl der Seitenaufrufe und Besuche</ListItem>
          <ListItem>Ihr ungefähres geografisches Gebiet (Land/Region)</ListItem>
          <ListItem>Informationen zu Browser und Endgerät</ListItem>
          <ListItem>verkürzte IP-Adresse</ListItem>
        </UnorderedList>
        <Text color="black">
          Wir nutzen Google Analytics grundsätzlich mit IP-Anonymisierung,
          sodass Ihre IP-Adresse innerhalb der EU/EWR gekürzt wird, bevor sie in
          die USA übertragen wird. Die von Ihrem Browser übermittelte IP-Adresse
          wird nicht mit anderen Daten von Google zusammengeführt.
        </Text>
        <Text color="black" fontWeight="semibold">
          Zwecke der Verarbeitung
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Auswertung der Nutzung unserer Website</ListItem>
          <ListItem>Reichweitenmessung</ListItem>
          <ListItem>
            Verbesserung unserer Inhalte und Nutzerfreundlichkeit
          </ListItem>
        </UnorderedList>
        <Text color="black">
          Rechtsgrundlage ist Ihre Einwilligung nach: § 25 Abs. 1 TTDSG (für das
          Setzen/Auslesen der Cookies) und Art. 6 Abs. 1 lit. a DSGVO (für die
          anschließende Datenverarbeitung).
        </Text>
        <Text color="black" fontWeight="semibold">
          Speicherdauer
        </Text>
        <Text color="black">
          Die in Google Analytics gespeicherten Nutzungsdaten werden nach einem
          von uns vorgegebenen Zeitraum von in der Regel 14 Monaten automatisch
          gelöscht.
        </Text>
        <Text color="black" fontWeight="semibold">
          Datenübermittlung in Drittländer
        </Text>
        <Text color="black">
          Daten können an Server von Google LLC in den USA übertragen und dort
          verarbeitet werden. Google stützt sich hierbei auf
          EU-Standardvertragsklauseln i. S. d. Art. 46 DSGVO als geeignete
          Garantie. Dennoch kann ein Restrisiko bestehen, dass US-Behörden auf
          Daten zugreifen.
        </Text>
        <Text color="black">
          Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen
          auf unserer Website widerrufen. Zusätzlich können Sie das
          Browser-Add-on zur Deaktivierung von Google Analytics verwenden, das
          von Google bereitgestellt wird:{" "}
          <Link
            href="https://tools.google.com/dlpage/gaoptout?hl=de"
            target="_blank"
            rel="nofollow"
            color={color.mainColor}
          >
            https://tools.google.com/dlpage/gaoptout?hl=de
          </Link>
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="9-hosting"
          style={{ color: color.mainColor }}
        >
          9. Hosting der Website
        </Heading>
        <Text color="black">
          Unsere Webseiten werden bei externen Dienstleistern gehostet, z. B.:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen,
            Deutschland
          </ListItem>
          <ListItem>
            Hostinger International Ltd. (bzw. ein europäisches
            Tochterunternehmen)
          </ListItem>
        </UnorderedList>
        <Text color="black">
          Die von Ihnen im Rahmen der Nutzung unserer Website übermittelten
          Daten (insbesondere IP-Adresse, Logfiles, Formulardaten) werden auf
          den Servern dieser Dienstleister verarbeitet.
        </Text>
        <Text color="black">
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (unser berechtigtes
          Interesse an der sicheren und effizienten Bereitstellung unserer
          Website). Soweit die Verarbeitung im Rahmen einer Auftragsverarbeitung
          erfolgt, ist zusätzlich Art. 28 DSGVO einschlägig. Mit den
          Hosting-Anbietern schließen wir – soweit erforderlich – Verträge zur
          Auftragsverarbeitung gemäß Art. 28 DSGVO.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="10-microsoft365"
          style={{ color: color.mainColor }}
        >
          10. E-Mail-Kommunikation über Microsoft 365
        </Heading>
        <Text color="black">
          Unsere E-Mail-Kommunikation erfolgt über Microsoft 365 (Outlook),
          einen Dienst der Microsoft Ireland Operations Limited, One Microsoft
          Place, South County Business Park, Leopardstown, Dublin 18, D18 P521,
          Irland. Sämtliche E-Mails, die Sie an uns senden (z. B.
          Kontaktanfragen, Bewerbungen), werden über die Infrastruktur von
          Microsoft verarbeitet.
        </Text>
        <Text color="black">
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          (Vertrag/Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO
          (Kommunikation, IT-Sicherheit). Soweit Microsoft als
          Auftragsverarbeiter tätig wird, besteht ein entsprechender
          Auftragsverarbeitungsvertrag nach Art. 28 DSGVO. Daten können im
          Rahmen der Leistungserbringung auch in Drittländer (z. B. USA)
          übertragen werden; Microsoft verwendet hierfür u. a.
          Standardvertragsklauseln als geeignete Garantien.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="11-empfaenger"
          style={{ color: color.mainColor }}
        >
          11. Empfänger und Kategorien von Empfängern
        </Heading>
        <Text color="black">
          Wir geben personenbezogene Daten nur an Dritte weiter, wenn:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            dies zur Vertragsabwicklung oder zur Durchführung vorvertraglicher
            Maßnahmen erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO),
          </ListItem>
          <ListItem>
            wir gesetzlich dazu verpflichtet sind (Art. 6 Abs. 1 lit. c DSGVO),
          </ListItem>
          <ListItem>
            die Weitergabe auf unserem berechtigten Interesse oder dem eines
            Dritten im Sinne von Art. 6 Abs. 1 lit. f DSGVO beruht und kein
            überwiegendes schutzwürdiges Interesse Ihrerseits entgegensteht,
            oder
          </ListItem>
          <ListItem>
            Sie hierin eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO).
          </ListItem>
        </UnorderedList>
        <Text color="black">Mögliche Empfänger sind insbesondere:</Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Hosting-Provider</ListItem>
          <ListItem>
            Anbieter von Webanalyse- und Marketing-Tools (z. B. Google, Meta)
          </ListItem>
          <ListItem>
            IT-Dienstleister, Wartungs- und Supportdienstleister
          </ListItem>
          <ListItem>E-Mail- und Cloud-Dienstleister (Microsoft 365)</ListItem>
        </UnorderedList>
        <Text color="black">
          Diese Dienstleister werden – soweit erforderlich – im Rahmen einer
          Auftragsverarbeitung tätig und nach Art. 28 DSGVO vertraglich auf die
          Einhaltung der datenschutzrechtlichen Vorgaben verpflichtet.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="12-speicherdauer"
          style={{ color: color.mainColor }}
        >
          12. Speicherdauer und Löschung von Daten
        </Heading>
        <Text color="black">
          Soweit in dieser Datenschutzerklärung keine abweichenden konkreten
          Speicherdauern genannt sind, gilt:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>
            personenbezogene Daten werden gelöscht, sobald der Zweck der
            Speicherung entfällt,
          </ListItem>
          <ListItem>
            eine darüber hinausgehende Speicherung erfolgt nur, wenn und solange
            gesetzliche Aufbewahrungspflichten (z. B. nach Handels- und
            Steuerrecht) oder andere gesetzliche Pflichten bestehen oder wir ein
            berechtigtes Interesse an der weiteren Speicherung haben (z. B. zur
            Abwehr oder Geltendmachung von Rechtsansprüchen,
            Verjährungsfristen).
          </ListItem>
        </UnorderedList>
        <Text color="black">
          Nach Ablauf der Aufbewahrungsfristen werden die Daten routinemäßig
          gelöscht.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="13-rechte"
          style={{ color: color.mainColor }}
        >
          13. Ihre Rechte als betroffene Person
        </Heading>
        <Text color="black">
          Sie haben gegenüber uns verschiedene Rechte hinsichtlich der Sie
          betreffenden personenbezogenen Daten nach den Art. 15 bis 21 DSGVO:
        </Text>
        <UnorderedList pl={10} color="black">
          <ListItem>Recht auf Auskunft (Art. 15 DSGVO)</ListItem>
          <ListItem>Recht auf Berichtigung (Art. 16 DSGVO)</ListItem>
          <ListItem>Recht auf Löschung (Art. 17 DSGVO)</ListItem>
          <ListItem>
            Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)
          </ListItem>
          <ListItem>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</ListItem>
          <ListItem>
            Widerspruchsrecht (Art. 21 DSGVO) gegen Verarbeitungen, die auf Art.
            6 Abs. 1 lit. e oder f DSGVO beruhen.
          </ListItem>
        </UnorderedList>
        <Text color="black">
          Soweit die Verarbeitung auf Ihrer Einwilligung beruht (Art. 6 Abs. 1
          lit. a DSGVO), haben Sie das Recht, diese Einwilligung jederzeit mit
          Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO). Zur
          Ausübung Ihrer Rechte können Sie uns jederzeit unter{" "}
          <Link href="mailto:info@target-ki.de" color={color.mainColor}>
            info@target-ki.de
          </Link>{" "}
          kontaktieren. Sie haben außerdem das Recht, sich bei einer
          Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
          personenbezogenen Daten durch uns zu beschweren (Art. 77 DSGVO).
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="14-widerspruch"
          style={{ color: color.mainColor }}
        >
          14. Widerspruchsrecht nach Art. 21 DSGVO
        </Heading>
        <Text color="black">
          Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
          Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender
          personenbezogener Daten, die auf Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse) beruht, Widerspruch einzulegen. Werden
          personenbezogene Daten verarbeitet, um Direktwerbung zu betreiben,
          haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung zu
          diesem Zweck einzulegen; dies gilt auch für das Profiling, soweit es
          mit solcher Direktwerbung in Verbindung steht. Im Falle des
          Widerspruchs verarbeiten wir Ihre personenbezogenen Daten nicht mehr,
          es sei denn, wir können zwingende schutzwürdige Gründe für die
          Verarbeitung nachweisen.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="15-datensicherheit"
          style={{ color: color.mainColor }}
        >
          15. Datensicherheit
        </Heading>
        <Text color="black">
          Wir treffen angemessene technische und organisatorische Maßnahmen nach
          Art. 32 DSGVO, um ein dem Risiko angemessenes Schutzniveau Ihrer
          personenbezogenen Daten zu gewährleisten. Dazu gehören insbesondere:
          Verwendung von TLS-/SSL-Verschlüsselung bei der Übertragung von Daten,
          Zugriffsbeschränkungen und Berechtigungskonzepte, regelmäßige
          Datensicherungen (Backups) sowie der Einsatz aktueller Sicherheits-
          und Schutzmaßnahmen in unseren IT-Systemen. Bitte beachten Sie, dass
          die Datenübertragung im Internet (z. B. bei der Kommunikation per
          E-Mail) Sicherheitslücken aufweisen kann. Ein vollständiger Schutz der
          Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </Text>

        <Heading
          as={"h2"}
          size="lg"
          id="16-aenderungen"
          style={{ color: color.mainColor }}
        >
          16. Änderungen dieser Datenschutzerklärung
        </Heading>
        <Text color="black">
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an
          geänderte rechtliche Vorgaben oder bei Änderungen unserer Leistungen
          (z. B. Einführung neuer Tools oder Dienste) anzupassen. Für Ihren
          Besuch gilt jeweils die auf unserer Website veröffentlichte aktuelle
          Version.
        </Text>

        <Divider />

        <Box display="none">
          <Heading
            as={"h1"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Text color="black">Datenschutzerklärung</Text>
          </Heading>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black"> Einleitung und allgemeine Angaben</Box>
          </Heading>
          <Text textAlign={"left"}>
            Vielen Dank für Ihr Interesse an unserer Website. Der Schutz Ihrer
            personenbezogenen Daten ist uns ein sehr wichtiges Anliegen. Im
            Folgenden finden Sie Informationen zum Umgang mit Ihren Daten, die
            durch Ihre Nutzung unserer Website erfasst werden. Die Verarbeitung
            Ihrer Daten erfolgt entsprechend den gesetzlichen Regelungen zum
            Datenschutz.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">
              {" "}
              Verantwortliche Stelle im Sinne des Datenschutzrechts
            </Box>
          </Heading>
          <Text textAlign={"left"}>
            Lukas Körber
            <br />
            Dubenhorst 9
            <br />
            24114 Kiel
            <br />
            lukas.koerber@gmx.net
            <br />
            017652856236
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Begriffsbestimmungen</Box>
          </Heading>
          <Text textAlign={"left"}>
            Unsere Datenschutzerklärung soll für jedermann einfach und
            verständlich sein. In dieser Datenschutzerklärung werden in der
            Regel die offiziellen Begriffe der Datenschutzgrundverordnung
            (DSGVO) verwendet. Die offiziellen Begriffsbestimmungen werden in
            Art. 4 DSGVO erläutert.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">
              {" "}
              Datenverarbeitung durch den Besuch unserer Website
            </Box>
          </Heading>
          <Text textAlign={"left"}>
            Wenn Sie unsere Webseiten aufrufen, ist es technisch notwendig, dass
            über Ihren Internetbrowser Daten an unseren Webserver übermittelt
            werden. Folgende Daten werden während einer laufenden Verbindung zur
            Kommunikation zwischen Ihrem Internetbr/owser und unserem Webserver
            aufgezeichnet:
          </Text>
          <UnorderedList textAlign={"left"} pl={10}>
            <ListItem>Datum und Uhrzeit der Anforderung</ListItem>
            <ListItem>Name der angeforderten Datei</ListItem>
            <ListItem>Seite, von der aus die Datei angefordert wurde</ListItem>
            <ListItem>Zugriffsstatus</ListItem>
            <ListItem>
              Verwendeter Webbr/owser und verwendetes Betriebssystem
            </ListItem>
            <ListItem>
              (Vollständige) IP-Adresse des anfordernden Rechners
            </ListItem>
            <ListItem>Übertragene Datenmenge</ListItem>
          </UnorderedList>
          <Text textAlign={"left"}>
            Die aufgelisteten Daten erheben wir, um einen reibungslosen
            Verbindungsaufbau der Website zu gewährleisten und eine komfortable
            Nutzung unserer Website durch die Nutzer zu ermöglichen. Zudem dient
            die Logdatei der Auswertung der Systemsicherheit und -stabilität
            sowie administrativen Zwecken. Rechtsgrundlage für die
            vorübergehende Speicherung der Daten bzw. der Logfiles ist Art. 6
            Abs. 1 lit. f DSGVO.
          </Text>
          <Text textAlign={"left"}>
            Aus Gründen der technischen Sicherheit, insbesondere zur Abwehr von
            Angriffsversuchen auf unseren Webserver, werden diese Daten von uns
            kurzzeitig gespeichert. Anhand dieser Daten ist uns ein Rückschluss
            auf einzelne Personen nicht möglich. Nach spätestens{" "}
            <b>
              <span>sieben Tage</span>
            </b>
            werden die Daten durch Verkürzung der IP-Adresse auf Domainebene
            anonymisiert, sodass es nicht mehr möglich ist, einen Bezug zum
            einzelnen Nutzer herzustellen.
          </Text>
          <Text textAlign={"left"}>
            In anonymisierter Form werden die Daten daneben ggf. zu
            statistischen Zwecken verarbeitet. Eine Speicherung dieser Daten
            zusammen mit anderen personenbezogenen Daten des Nutzers, ein
            Abgleich mit anderen Datenbeständen oder eine Weitergabe an Dritte
            findet zu keinem Zeitpunkt statt.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">
              {" "}
              Kontaktformular und Kontaktaufnahme per E-Mail
            </Box>
          </Heading>
          <Text textAlign={"left"}>
            Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen
            lassen, werden Ihre Angaben aus dem Anfrageformular bzw. Ihrer
            E-Mail inklusive der von Ihnen dort angegebenen{" "}
            <b> Vor- und Nachname, Anrede, Postanschrift </b> zwecks Bearbeitung
            der Anfrage und für den Fall von Anschlussfragen bei uns
            gespeichert. Die Angabe einer E-Mail-Adresse ist zur Kontaktangabe
            erforderlich, die Angabe Ihres Namens sowie Ihrer Telefonnummer ist
            freiwillig. Diese Daten geben wir in keinem Fall ohne Ihre
            Einwilligung weiter. Rechtsgrundlage für die Verarbeitung der Daten
            ist unser berechtigtes Interesse an der Beantwortung Ihres Anliegens
            gemäß Art. 6 Abs. 1 lit. f DSGVO sowie ggf. Art. 6 Abs. 1 lit. b
            DSGVO, sofern Ihre Anfrage auf den Abschluss eines Vertrages
            abzielt. Ihre Daten werden nach abschließender Bearbeitung Ihrer
            Anfrage gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
            entgegenstehen. Sie können im Falle von Art. 6 Abs. 1 lit. f DSGVO
            gegen die Verarbeitung Ihrer personenbezogenen Daten jederzeit
            Widerspruch einlegen.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">
              {" "}
              Meta Pixel und weitere Meta Marketing Dienste und Funktionen: Meta
              Conversion-Tracking, Meta Custom Audiences, Meta Retargeting, Meta
              Ads Werbeanzeigenmanager 
            </Box>
          </Heading>
          <Text textAlign={"left"}>
            Auf unseren Webseiten binden wir das „Meta Pixel“ der Meta Inc., 1
            Hacker Way, Menlo Park, CA 94025, USA, ein. In der Europäischen
            Union (EU) und im Europäischen Wirtschaftsraum (EWR) wird der Dienst
            von Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2,
            Irland, angeboten.
          </Text>
          <Heading
            as={"h4"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">
              {" "}
              Beschreibung der Datenverarbeitung und des Zwecks
            </Box>
          </Heading>
          <Text textAlign={"left"}>
            Wir nutzen das Meta Pixel und weitere Meta Marketing Dienste und
            Funktionen wie die Meta Custom Audiences, das Meta Conversion
            Tracking, das Meta Retargeting und den Meta Ads
            Werbeanzeigenmanager, um für unsere Produkte und Dienstleistungen
            zielgruppenorientierte Werbeanzeigen auf den Meta Social Media
            Plattformen Facebook und Instagram schalten und steuern zu können
            sowie um messen zu können, wie erfolgreich diese Werbeanzeigen
            sind.  <br />
            <br />
            Die Datenerhebung und Verarbeitung auf unserer Webseite erfolgt
            dabei über das „Meta Pixel“. Dabei handelt es sich um einen
            JavaScript Code, der beim Seitenaufruf geladen und im Browser Ihres
            Endgerätes ausgeführt wird. Mithilfe dieses JavaScript Codes können
            dann Cookies in Ihrem Endgerät gespeichert und verschiedene
            Informationen aus Ihrem Endgerät sowie aus dort abgelegten Cookies
            ausgelesen werden. 
            <br />
            <br />
            Auf diese Weise ist es uns möglich, Webseitenbesucher und die von
            Ihnen verwendeten Endgeräte pseudonym wiederzuerkennen. Besucher,
            die über einen eigenen Benutzeraccount auf den Meta Social Media
            Plattform verfügen, können durch Meta außerdem geräteübergreifend
            als Besucher unserer Webseiten identifiziert werden. 
            <br />
            <br />
            Zudem ermöglicht uns das „Meta Pixel“ Ihre Interessen anhand der von
            Ihnen besuchten Webseiten sowie anhand Ihrer Interaktionen mit
            unseren Webseiten nachzuverfolgen und auszuwerten.
            <br />
            <br />
            Zu den Informationen, die über das „Meta Pixel“ ausgelesen werde,
            gehören insbesondere 
          </Text>
          <UnorderedList textAlign={"left"} pl={10}>
            <ListItem>
              Informationen, die beim Aufruf einer Webseite im Browser Ihres
              Endgerätes im sog. HTTP-Header enthalten sind, insbesondere
              Nutzungsdaten wie IP-Adresse, Informationen über den verwendeten
              Webbrowser, den Standort der Seite, die abgerufenen Dateien, dem
              Referral-Link, der angibt, von welcher Seite Sie auf unsere
              gelangt sind,
            </ListItem>
            <ListItem>
              Merkmale des von Ihnen beim Aufruf unserer Webseiten genutzten
              Endgeräts,
            </ListItem>
            <ListItem>
              Im Browser Ihres Endgeräts gegebenenfalls bereits vorhandene
              Cookies, die von Meta Diensten gesetzt worden sind, z.B.
              Marketing-Cookies „_fbp“ und „fr“,
            </ListItem>
            <ListItem>
              Schaltflächenklickdaten, also Daten darüber, welche Schaltflächen
              auf den Webseiten von Besuchern angeklickt wurden, die
              Beschriftungen dieser Schaltflächen und alle Seiten, die als
              Ergebnis der Schaltflächenklicks besucht wurden, dies betrifft
              z.B. das Anklicken von Schaltflächen in Webformularen zu
              Produktanfragen bzw. -demonstrationen, zum Download von Dokumenten
              oder zur Buchung von Terminen. 
            </ListItem>
          </UnorderedList>
          <Text textAlign={"left"}>
            Aus diesen Informationen erstellt Meta für uns im Rahmen des „Meta
            Conversion Tracking“ im „Meta Ads Werbeanzeigenmanager“ Statistiken,
            aus denen wir erkennen können, wie viele Nutzer auf welche Weise auf
            unsere auf den Meta Social Media Plattformen geschalteten
            Werbeanzeigen reagiert haben. Die Umsetzung einer Werbeanzeige in
            eine Handlung des Webseitenbesuchers wird als Conversion bezeichnet.
            Auf Grundlage dieser Statistiken können wir die Wirksamkeit unsere
            Werbung optimieren und unsere Werbestrategie steuern.
            <br />
            <br />
            Darüber hinaus nutzen wir die über das „Meta Pixel“ auf unseren
            Webseiten erhobenen Informationen, um im „Meta Ads
            Werbeanzeigenmanager“ sog. „Meta Custom Audiences“
            (benutzerdefinierte Zielgruppen) anzulegen und für diese
            zielgruppenorientierte Werbung auf den Meta Social Media Plattform
            zu schalten. So können wir z.B. auf den Plattformen Werbeanzeigen
            für Webseitenbesucher schalten, die sich innerhalb eines bestimmten
            Zeitraums zuvor bereits für unsere Produkte, Dienstleistungen oder
            Aktionen interessiert und unsere Webseiten besucht hatten. Diese Art
            zielgerichteter Werbung wird als Retargeting bezeichnet.
          </Text>
          <Heading
            as={"h4"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Rechtsgrundlage der Datenverarbeitung</Box>
          </Heading>
          <Text>
            Rechtsgrundlage der Einbindung und Nutzung des Dienstes ist Ihre
            Einwilligung, sofern Sie diese über unsere
            Consent-Management-Plattform „ConsentManager“ abgegeben haben.
            <br />
            <br />
            Der Einsatz von Cookies und ähnlichen Technologien erfolgt auf
            Grundlage von § 25 Abs. 1 TTDSG. Die anschließende Datenverarbeitung
            beruht auf Art. 6 Abs. 1 S. 1 lit. a DSGVO.
            <br />
            <br />
            Ihre Einwilligung ist freiwillig und kann jederzeit frei mit Wirkung
            für die Zukunft widerrufen werden. Um Ihren Widerruf auszuüben,
            nutzen Sie bitte das Fingerabdrucksymbol links unten am Ende der
            Webseite, um „ConsentManager“ erneut aufzurufen und Ihre
            Einstellungen zu ändern.
          </Text>{" "}
          <Heading
            as={"h4"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Datenverarbeitung in Drittstaaten</Box>
          </Heading>
          <Text>
            Die Verarbeitung Ihrer Daten kann beim Einsatz des Dienstes auch in
            Staaten außerhalb der Europäischen Union (EU) und des Europäischen
            Wirtschaftsraums (EWR) in Drittstaaten ohne angemessenes
            Datenschutzniveau, insbesondere in den USA, erfolgen.
            <br />
            <br />
            Bei einer Übermittlung Ihrer Daten in Drittstaaten besteht das
            Risiko, dass dortige Behörden auf Ihre Daten zu Sicherheits- und
            Überwachungszwecken zugreifen, ohne dass Sie hierüber informiert
            werden oder Rechtsmittel einlegen können.
            <br />
            <br />
            Zur Absicherung eines angemessenen Datenschutzniveaus bei der
            Übermittlung Ihrer Daten in Drittstaaten werden
            Standarddatenschutzklauseln der Europäischen Kommission gemäß Art.
            46 Abs. 2 lit. c DSGVO abgeschlossen. Sie verpflichten den Empfänger
            der Daten, diese entsprechend dem europäischen Schutzniveau zu
            verarbeiten.
            <br />
            <br />
            Soweit die Standartdatenschutzklauseln allein nicht ausreichen, um
            das Schutzniveau zu gewährleisten, werden zusätzliche technische,
            vertragliche bzw. organisatorische Maßnahmen zur Absicherung der
            Datenübermittlung ergriffen. Außerdem wird regelmäßig überprüft und
            bewertet, ob diese zusätzlichen Maßnahmen weiterhin ein
            hinreichendes Datenschutzniveau gewährleisten oder ob gegebenenfalls
            weitere ergänzende Maßnahmen ergriffen werden müssen. 
          </Text>
          <Heading
            as={"h4"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Empfänger</Box>
          </Heading>
          <Text>
            Im Rahmen der Nutzung des Dienstes werden die über unsere Webseiten
            erhobenen Daten an nachfolgende Empfänger übermittelt:
          </Text>{" "}
          <UnorderedList textAlign={"left"} pl={10}>
            <ListItem>
              Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2,
              Irland,
            </ListItem>
            <ListItem>
              Meta Inc., 1 Hacker Way, Menlo Park, CA 94025, USA.{" "}
            </ListItem>
          </UnorderedList>
          <Text>
            Auf eine weitere Datenverarbeitung durch den Drittanbieter haben wir
            grundsätzlich keinen Einfluss. <br />
            <br />
            Weitere Informationen zum Umgang mit personenbezogenen Daten durch
            Meta finden Sie unter 
            <a
              href={"https://de-de.facebook.com/privacy/policy/"}
              target={"_blank"}
              rel={"nofollow"}
            >
              https://de-de.facebook.com/privacy/policy/
            </a>
            .
          </Text>
          <Heading
            as={"h4"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Speicherdauer</Box>
          </Heading>
          <Text>
            Durch die Einbindung des Dienstes auf unseren Webseiten werden Daten
            an die oben genannten Empfänger übermittelt und dort für die Dauer
            von 24 Monaten gespeichert. 
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Google Analytics</Box>
          </Heading>
          <Text textAlign={"left"}>
            Unsere Website nutzt Google Analytics, einen Internetanalysedienst,
            der von Google Ireland Limited, Gordon House, Barrow Street, Dublin
            4, Irland ("Google") zur Verfügung gestellt wird. Google Analytics
            verwendet sogenannte "Cookies".{" "}
          </Text>
          <Text textAlign={"left"}>
            Google wird diese Informationen im Auftrag des Betreibers dieser
            Website benutzen, um Ihre Nutzung der Website auszuwerten und um
            Reports über die Websiteaktivitäten zu erstellen. Google wird diese
            Informationen auch dazu verwenden, dem Website-Betreiber weitere,
            mit der Nutzung der Website und des Internets verbundene,
            Dienstleistungen zu erbr/ingen. Die von Ihrem br/owser im Rahmen von
            Google Analytics gesendete IP-Adresse wird nicht mit anderen Daten
            von Google kombiniert. Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1
            lit. f DSGVO auf Grundlage unseres berechtigten Interesses an der
            statistischen Analyse des Nutzerverhaltens zu Optimierungs- und
            Marketingzwecken.
          </Text>
          <Text textAlign={"left"}>
            Wir verwenden Google Analytics nur mit aktivierter
            IP-Anonymisierung. Das bedeutet, Ihre IP-Adresse wird von Google nur
            gekürzt weiterverarbeitet. Wir haben mit dem Dienstleister einen
            Auftragsverarbeitungsvertrag geschlossen, in welchem wir ihn
            verpflichten, die Daten unserer Kunden zu schützen und sie nicht an
            Dritte weiterzugeben. Da eine Übertragung personenbezogener Daten in
            die USA erfolgt, sind weitere Schutzmechanismen erforderlich, die
            das Datenschutzniveau der DSGVO sicherstellen. Um dies zu
            gewährleisten, haben wir mit dem Anbieter
            Standarddatenschutzklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO
            vereinbart. Diese verpflichten den Empfänger der Daten in den USA
            die Daten entsprechend dem Schutzniveau in Europa zu verarbeiten. In
            Fällen, in denen dies auch durch diese vertragliche Erweiterung
            nicht sichergestellt werden kann, bemühen wir uns um
            darüberhinausgehende Regelungen und Zusagen des Empfängers in den
            USA. Die Nutzungsbedingungen von Google Analytics und Informationen
            zum Datenschutz können über die folgenden Links abgerufen werden:
            <a
              href="http://www.google.com/analytics/terms/de.html"
              rel="nofollow"
              target="_blank"
            >
              http://www.google.com/analytics/terms/de.html
            </a>
            <a
              href="https://www.google.de/intl/de/policies/"
              rel="nofollow"
              target="_blank"
            >
              https://www.google.de/intl/de/policies/
            </a>
            <br />
            Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes
            ihrer Erhebung nicht mehr erforderlich sind. Eine Löschung der Daten
            auf Nutzer- und Ereignisebene, die mit Cookies, Nutzerkennungen (z.
            B. User-ID) und Werbe-IDs (z. B. DoubleClick-Cookies,
            Android-Werbe-ID, IDFA [Apple-Kennung für Werbetreibende]) verknüpft
            sind erfolgt spätestens 14 Monate nach ihrer Erhebung.
            <br />
            Sie können das Speichern von Cookies verhindern, indem Sie die
            Einstellungen Ihrer br/owser-Software entsprechend anpassen. Wir
            weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls
            nicht alle Funktionen dieser Website uneingeschränkt nutzen können.
            Sie können auch verhindern, dass Google die durch den Cookie
            erzeugten Daten sammelt und Ihre Nutzung der Website (einschließlich
            Ihrer IP-Adresse) analysiert und diese Daten durch Google
            verarbeitet, indem Sie das br/owser-Plugin herunterladen und
            installieren, das unter{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=de"
              rel="nofollow"
              target="_blank"
            >
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>
            verfügbar ist.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Cookies</Box>
          </Heading>
          <Text textAlign={"left"}>
            Unsere Website setzt Cookies ein, die vom br/owser auf Ihrem Gerät
            gespeichert werden und die bestimmte Einstellungen zur Nutzung der
            Website enthalten (z. B. zur laufende Sitzung). Cookies dienen dazu,
            unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
            Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt
            werden und die Ihr br/owser speichert. Die meisten der von uns
            verwendeten Cookies sind so genannte Session-Cookies, welche nach
            dem Schließen des br/owsers automatisch gelöscht werden. Andere
            Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese
            löschen oder die Speicherdauer abläuft. Diese Cookies ermöglichen es
            uns, Ihren br/owser beim nächsten Besuch wiederzuerkennen.
          </Text>
          <Text textAlign={"left"}>
            Teilweise dienen die Cookies dazu, durch Speicherung von
            Einstellungen Websiteprozesse zu vereinfachen (z. B. das Vorhalten
            bereits ausgewählter Optionen). Sofern durch einzelne von uns
            implementierte Cookies auch personenbezogene Daten verarbeitet
            werden, erfolgt die Verarbeitung gemäß Art. 6 Abs. 1 lit. b DSGVO
            entweder zur Durchführung des Vertrages oder gemäß Art. 6 Abs. 1
            lit. f DSGVO zur Wahrung unserer berechtigten Interessen an der
            bestmöglichen Funktionalität der Website sowie einer
            kundenfreundlichen und effektiven Ausgestaltung des Seitenbesuchs.
            Sie können Ihren br/owser so einstellen, dass Sie über das Setzen
            von Cookies informiert werden und Cookies nur im Einzelfall
            erlauben, die Annahme von Cookies für bestimmte Fälle oder generell
            ausschließen sowie das automatische Löschen der Cookies beim
            Schließen des br/owsers aktivieren. Die Cookie Einstellungen können
            unter den folgenden Links für die jeweiligen br/owser verwaltet
            werden.
          </Text>
          <UnorderedList textAlign={"left"} pl={10}>
            <ListItem>
              Firefox:{" "}
              <a
                href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen"
                target="_blank"
                rel="nofollow"
              >
                https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen
              </a>
            </ListItem>
            <ListItem>
              Internet Explorer:{" "}
              <a
                href="http://windows.microsoft.com/de-DE/windows-vista/Block-or-allow-cookies"
                target="_blank"
                rel="nofollow"
              >
                http://windows.microsoft.com/de-DE/windows-vista/Block-or-allow-cookies
              </a>
            </ListItem>
            <ListItem>
              Chrome:{" "}
              <a
                href="http://support.google.com/chrome/bin/answer.py?hl=de&amp;hlrm=en&amp;answer=95647"
                target="_blank"
                rel="nofollow"
              >
                http://support.google.com/chrome/bin/answer.py?hl=de&amp;hlrm=en&amp;answer=95647
              </a>
            </ListItem>
            <ListItem>
              Safari:{" "}
              <a
                href="https://support.apple.com/kb/ph21411?locale=de_DE"
                target="_blank"
                rel="nofollow"
              >
                https://support.apple.com/kb/ph21411?locale=de_DE
              </a>
            </ListItem>
            <ListItem>
              Opera:{" "}
              <a
                href="https://help.opera.com/en/latest/web-preferences/#cookies"
                target="_blank"
                rel="nofollow"
              >
                https://help.opera.com/en/latest/web-preferences/#cookies
              </a>
            </ListItem>
          </UnorderedList>
          <Text textAlign={"left"}>
            Sie können auch die Cookies vieler Unternehmen und Funktionen
            einzeln verwalten, die für Werbung eingesetzt werden. Verwenden Sie
            dazu die entsprechenden Nutzertools, abr/ufbar unter{" "}
            <a
              href="https://www.aboutads.info/choices/"
              rel="nofollow"
              target="_blank"
            >
              https://www.aboutads.info/choices/
            </a>
            oder{" "}
            <a
              href="http://www.youronlinechoices.com/uk/your-ad-choices"
              rel="nofollow"
              target="_blank"
            >
              http://www.youronlinechoices.com/uk/your-ad-choices
            </a>
            Die meisten br/owser bieten zudem eine sog. „Do-Not-Track-Funktion“
            an, mit der Sie angeben können, dass Sie nicht von Websites
            „verfolgt“ werden möchten. Wenn diese Funktion aktiviert ist, teilt
            der jeweilige br/owser Werbenetzwerken, Websites und Anwendungen
            mit, dass Sie nicht zwecks verhaltensbasierter Werbung und Ähnlichem
            verfolgt werden möchten. Informationen und Anleitungen, wie Sie
            diese Funktion bearbeiten können, erhalten Sie je nach Anbieter
            Ihres br/owsers, unter den nachfolgenden Links:
          </Text>
          <UnorderedList textAlign={"left"} pl={10}>
            <ListItem>
              Google Chrome:{" "}
              <a
                href="https://support.google.com/chrome/answer/2790761?co=GENIE.Platform%3DDesktop&amp;hl=de"
                target="_blank"
                rel="nofollow"
              >
                https://support.google.com/chrome/answer/2790761?co=GENIE.Platform%3DDesktop&amp;hl=de
              </a>
            </ListItem>
            <ListItem>
              Mozilla Firefox:{" "}
              <a
                href="https://www.mozilla.org/de/firefox/dnt/"
                target="_blank"
                rel="nofollow"
              >
                https://www.mozilla.org/de/firefox/dnt/
              </a>
            </ListItem>
            <ListItem>
              Internet Explorer:{" "}
              <a
                href="https://support.microsoft.com/de-de/help/17288/windows-internet-explorer-11-use-do-not-track"
                target="_blank"
                rel="nofollow"
              >
                https://support.microsoft.com/de-de/help/17288/windows-internet-explorer-11-use-do-not-track
              </a>
            </ListItem>
            <ListItem>
              Opera:{" "}
              <a
                href="http://help.opera.com/Windows/12.10/de/notrack.html"
                target="_blank"
                rel="nofollow"
              >
                http://help.opera.com/Windows/12.10/de/notrack.html
              </a>
            </ListItem>
            <ListItem>
              Safari:{" "}
              <a
                href="https://support.apple.com/kb/PH21416?locale=de_DE"
                target="_blank"
                rel="nofollow"
              >
                https://support.apple.com/kb/PH21416?locale=de_DE
              </a>
            </ListItem>
          </UnorderedList>
          <Text textAlign={"left"}>
            Zusätzlich können Sie standardmäßig das Laden sog. Scripts
            verhindern. NoScript erlaubt das Ausführen von JavaScripts, Java und
            anderen Plug-ins nur bei vertrauenswürdigen Domains Ihrer Wahl.
            Informationen und Anleitungen, wie Sie diese Funktion bearbeiten
            können, erhalten Sie über den Anbieter Ihres br/owsers (z. B. für
            Mozilla Firefox unter:{" "}
            <a
              href="https://addons.mozilla.org/de/firefox/addon/noscript/"
              rel="nofollow"
              target="_blank"
            >
              https://addons.mozilla.org/de/firefox/addon/noscript/
            </a>
            ). Bitte beachten Sie, dass bei der Deaktivierung von Cookies die
            Funktionalität dieser Website eingeschränkt sein kann.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black"> Datenweitergabe und Empfänger</Box>
          </Heading>
          <Text textAlign={"left"}>
            Eine Übermittlung Ihrer personenbezogenen Daten an Dritte findet
            nicht statt, außer
          </Text>
          <UnorderedList textAlign={"left"} pl={10}>
            <ListItem>
              wenn wir in der Beschreibung der jeweiligen Datenverarbeitung
              explizit darauf hingewiesen haben.
            </ListItem>
            <ListItem>
              wenn Sie ausdrückliche Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a
              DSGVO dazu erteilt haben,
            </ListItem>
            <ListItem>
              die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen
              erforderlich ist und kein Grund zur Annahme besteht, dass Sie ein
              überwiegendes schutzwürdiges Interesse an der Nichtweitergabe
              Ihrer Daten haben,
            </ListItem>
            <ListItem>
              im Falle, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c
              DSGVO eine gesetzliche Verpflichtung besteht und
            </ListItem>
            <ListItem>
              soweit dies nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die
              Abwicklung von Vertragsverhältnissen mit Ihnen erforderlich ist.
            </ListItem>
          </UnorderedList>
          <Text textAlign={"left"}>
            Wir nutzen darüber hinaus für die Abwicklung unserer Services
            externe Dienstleister, die wir sorgfältig ausgewählt und schriftlich
            beauftragt haben. Sie sind an unsere Weisungen gebunden und werden
            von uns regelmäßig kontrolliert. Mit welchen wir erforderlichenfalls
            Auftragsverarbeitungsverträge gem. Art. 28 DSGVO geschlossen haben.
            Diese sind Dienstleister für das Webhosting, den Versand von E-Mails
            sowie Wartung und Pflege unserer IT-Systemen usw. Die Dienstleister
            werden diese Daten nicht an Dritte weitergeben.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Datensicherheit</Box>
          </Heading>
          <Text textAlign={"left"}>
            Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung
            des Stands der Technik, der Implementierungskosten und der Art, des
            Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der
            unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des
            Risikos für die Rechte und Freiheiten natürlicher Personen,
            geeignete technische und organisatorische Maßnahmen, um ein dem
            Risiko angemessenes Schutzniveau zu gewährleisten. Diese Webseite
            nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung
            vertraulicher Inhalte eine SSL-Verschlüsselung.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">
              {" "}
              Dauer der Speicherung personenbezogener Daten
            </Box>
          </Heading>
          <Text textAlign={"left"}>
            Die Dauer der Speicherung von personenbezogenen Daten bemisst sich
            an den einschlägigen gesetzlichen Aufbewahrungsfristen (z. B. aus
            dem Handelsrecht und dem Steuerrecht). Nach Ablauf der jeweiligen
            Frist werden die entsprechenden Daten routinemäßig gelöscht. Sofern
            Daten zur Vertragserfüllung oder Vertragsanbahnung erforderlich sind
            oder unsererseits ein berechtigtes Interesse an der
            Weiterspeicherung besteht, werden die Daten gelöscht, wenn Sie zu
            diesen Zwecken nicht mehr erforderlich sind oder Sie von Ihrem
            Widerrufs- oder Widerspruchsrecht Gebr/auch gemacht machen.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black"> Ihre Rechte</Box>
          </Heading>
          <Text textAlign={"left"}>
            Im Folgenden finden Sie Informationen dazu, welche Betroffenenrechte
            das geltende Datenschutzrecht Ihnen gegenüber dem Verantwortlichen
            hinsichtlich der Verarbeitung Ihrer personenbezogenen Daten gewährt:
          </Text>
          <Text textAlign={"left"}>
            Das Recht, gemäß Art. 15 DSGVO Auskunft über Ihre von uns
            verarbeiteten personenbezogenen Daten zu verlangen.
            <br />
            Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die
            Kategorie der personenbezogenen Daten, die Kategorien von
            Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder
            werden, die geplante Speicherdauer, das Bestehen eines Rechts auf
            Berichtigung, Löschung, Einschränkung der Verarbeitung oder
            Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft ihrer
            Daten, sofern diese nicht bei uns erhoben wurden, sowie über das
            Bestehen einer automatisierten Entscheidungsfindung einschließlich
            Profiling und ggf. aussagekräftigen Informationen zu deren
            Einzelheiten verlangen.
          </Text>
          <Text textAlign={"left"}>
            Das Recht, gemäß Art. 16 DSGVO unverzüglich die Berichtigung
            unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten
            personenbezogenen Daten zu verlangen.
          </Text>
          <Text textAlign={"left"}>
            Das Recht, gemäß Art. 17 DSGVO die Löschung Ihrer bei uns
            gespeicherten personenbezogenen Daten zu verlangen, soweit nicht die
            Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und
            Information, zur Erfüllung einer rechtlichen Verpflichtung, aus
            Gründen des öffentlichen Interesses oder zur Geltendmachung,
            Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.
          </Text>
          <Text textAlign={"left"}>
            Das Recht, gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen, soweit die Richtigkeit
            der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig
            ist, Sie aber deren Löschung ablehnen und wir die Daten nicht mehr
            benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21
            DSGVO Widerspruch gegen die Verarbeitung eingelegt haben.
          </Text>
          <Text textAlign={"left"}>
            Das Recht, gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie
            uns bereitgestellt haben, in einem strukturierten, gängigen und
            maschinenlesebaren Format zu erhalten oder die Übermittlung an einen
            anderen Verantwortlichen zu verlangen.
          </Text>
          <Text textAlign={"left"}>
            Das Recht, sich gemäß Art. 77 DSGVO bei einer Aufsichtsbehörde zu
            beschweren. In der Regel können Sie sich hierfür an die
            Aufsichtsbehörde des Bundeslandes unseres oben angegebenen Sitzes
            oder ggf. die Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes
            wenden.
          </Text>
          <Text textAlign={"left"}>
            Recht auf Widerruf erteilter Einwilligungen gemäß Art. 7 Abs. 3
            DSGVO: Sie haben das Recht, eine einmal erteilte Einwilligung in die
            Verarbeitung von Daten jederzeit mit Wirkung für die Zukunft zu
            widerrufen. Im Falle des Widerrufs werden wir die betroffenen Daten
            unverzüglich löschen, sofern eine weitere Verarbeitung nicht auf
            eine Rechtsgrundlage zur einwilligungslosen Verarbeitung gestützt
            werden kann. Durch den Widerruf der Einwilligung wird die
            Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
            erfolgten Verarbeitung nicht berührt.
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black">Widerspruchsrecht</Box>
          </Heading>
          <Text textAlign={"left"} p>
            Sofern Ihre personenbezogenen Daten von uns auf Grundlage von
            berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO
            verarbeitet werden, haben Sie gemäß Art. 21 DSGVO das Recht,
            Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten
            einzulegen, soweit dies aus Gründe erfolgt, die sich aus Ihrer
            besonderen Situation ergeben. Soweit sich der Widerspruch gegen die
            Verarbeitung personenbezogener Daten zum Zwecke von Direktwerbung
            richtet, haben Sie ein generelles Widerspruchsrecht ohne das
            Erfordernis der Angabe einer besonderen Situation. Möchten Sie von
            Ihrem Widerrufs- oder Widerspruchsrecht Gebr/auch machen, genügt
            eine E-Mail{" "}
            <span>
              <a
                aria-label={`Nehme Kontakt zu WebWerk per Email auf`}
                href="mailto: widerspruch@webwerk-am-meer.de"
              >
                widerspruch@webwerk-am-meer.de
              </a>
            </span>
            .
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black"> Externe Verlinkungen</Box>
          </Heading>
          <Text textAlign={"left"}>
            Soziale Netzwerke (Facebook, Twitter, Xing etc.) sind auf unserer
            Webseite lediglich als Link zu den entsprechenden Diensten
            eingebunden. Nach dem Anklicken des eingebundenen Text-/Bild-Links
            werden Sie auf die Seite des jeweiligen Anbieters weitergeleitet.
            Erst nach der Weiterleitung werden Nutzerinformationen an den
            jeweiligen Anbieter übertragen. Informationen zum Umgang mit Ihren
            personenbezogenen Daten bei Nutzung dieser Webseiten entnehmen Sie
            bitte den jeweiligen Datenschutzbestimmungen der von Ihnen genutzten
            Anbieter.{" "}
          </Text>
          <Heading
            as={"h3"}
            style={{ color: color.mainColor, textDecoration: "underline" }}
          >
            <Box color="black"> Änderungsvorbehalt</Box>
          </Heading>
          <Text textAlign={"left"}>
            Wir behalten uns vor, diese Datenschutzerklärung erforderlichenfalls
            unter Beachtung der geltenden Datenschutzvorschriften anzupassen
            bzw. zu aktualisieren. Auf diese Weise können wir sie den aktuellen
            rechtlichen Anforderungen anpassen und Änderungen unserer Leistungen
            berücksichtigen, z. B. bei der Einführung neuer Services. Für Ihren
            Besuch gilt die jeweils aktuellste Fassung.
          </Text>
          <Text textAlign={"left"}>
            Diese Datenschutzerklärung wurde erstellt durch{" "}
            <a
              aria-label={`Gehe zu datenschutzexperte.de`}
              href="https://www.datenschutzexperte.de/"
              rel={"nofollow"}
            >
              www.datenschutzexperte.de
            </a>
          </Text>
          <p>
            Stand dieser Datenschutzerklärung: <span>8.9.2022</span>
          </p>
        </Box>
      </Stack>
      <Footer />
    </>
  );
}
